export enum TaskState {
    PENDING = 'PENDING',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
  }
  
export interface IAddressResolutionTask {
    task_id: string;
    status: TaskState;
    progress: number;
    created_at: string;
    uploaded_file_url?: string | null;
    result_summary: Record<string, string | null>;
}

export interface IShopifyOrderImportTask {
    task_id: string;
    status: TaskState;
    progress: number;
    created_at: string;
    result: {
        success: number;
        failed: number;
        skipped: number;
    }
}
  export interface IWoocommerceOrderImportTask {
    task_id: string;
    status: TaskState;
    progress: number;
    created_at: string;
    result: {
        success: number;
        failed: number;
        skipped: number;
    }
}

export interface IWoocommerceSyncTask {
    task_id: string;
    status: TaskState;
    progress: number;
    created_at: string;
    result: {
        created: number;
        updated: number;
        failed: number;
    }
}
